import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import Modal from "./modal";
import * as WS from '../webServices/cyMyManager';
import { GlobalContextData, GetGlobalContext } from "../classes/context";


type ActionBtnProps = {
    modello: string;
    add: boolean;
    del: boolean;
    onDel?: () => void;
    modalBody?: React.ReactNode;
    modalOnSave?: () => Promise<WS.Plus.IF.GenericResponse>;
    modalOnClose?: () => void;
    onNew?: () => void;
    sedi?: WS.Plus.IF.SedeEsercente[];
    sedeSel?: string;
    setSedeSel?: Dispatch<SetStateAction<string | undefined>>;
}

export default function ActionBtn(props: ActionBtnProps): JSX.Element {
    const [modalShow, setModalShow] = useState(false);
    const [sedi, setSedi] = useState<WS.Plus.IF.SedeEsercente[] | undefined>(props.sedi);

    const globalContext = useContext<GlobalContextData>(GetGlobalContext);

    useEffect(() => {
        if (props.sedi == undefined)
            WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 0, 0).then(sedi => setSedi(sedi.list))

    }, []);

    return (
        <>
            {props.sedeSel && props.setSedeSel &&
                <div className="mb-3 mt-3 mb-md-0 mt-md-0" style={{ display: 'inline-block', marginRight: '0.5em' }}>
                    <select name="sedEseSel" className='form-select' value={props.sedeSel} onChange={(s) => props.setSedeSel?.(s.target.value)}>
                        {sedi ?
                            sedi.map((sede, s) =>
                                <option key={s} value={sede.Id}>{sede.Indirizzo}</option>
                            )
                            :
                            undefined
                        }
                    </select>
                </div>
            }
            {props.add &&
                <button className="btn btn-success me-2" onClick={() => { setModalShow(true); props.onNew?.() }}>
                    <i className="bi bi-plus me-2"></i>
                    Aggiungi
                </button>
            }
            {props.del &&
                <button className="btn btn-danger" onClick={() => {
                    props.onDel?.()
                }}>
                    <i className="bi bi-trash me-2"></i>
                    Rimuovi
                </button>
            }

            <Modal
                isShow={modalShow}
                title={"Inserisci " + props.modello}
                onSave={async () => {
                    let res = await props.modalOnSave?.()

                    if (res?.isOk)
                        setModalShow(false)
                    else
                        alert('ERRORE: ' + res?.msgErr ?? '')
                }}
                onClose={() => {
                    props.modalOnClose?.()
                    setModalShow(false)
                }}
                body={props.modalBody}
            />
        </>
    );
}